import type {StatusType} from './typings';

import {
  LOAD_HERO_FAILURE,
  LOAD_HERO_REQUEST,
  LOAD_HERO_SUCCESS,
  STATUS_FAILED,
  STATUS_IDLE,
  STATUS_LOADING,
  STATUS_SUCCEEDED,
} from '../actionTypes';
import {HomePageSlideProps} from '@/molecules/Slides/HomePage/typings';

const initialState: HeroReducerProps = {
  status: STATUS_IDLE,
  data: [],
  error: null,
};

const heroReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_HERO_REQUEST:
      return {...state, status: STATUS_LOADING};
    case LOAD_HERO_SUCCESS:
      return {status: STATUS_SUCCEEDED, data: action.response.data, error: null};
    case LOAD_HERO_FAILURE:
      return {...state, status: STATUS_FAILED, error: action.error};
    default:
      return {...state};
  }
};

export default heroReducer;

export const selectHeroState = (state): HeroReducerProps => state.hero;

interface HeroReducerProps {
  status: StatusType;
  data: HomePageSlideProps[];
  error: string | null;
}
